import ServiceDetail from '../components/services/ServiceDetail';

export default function Automatizacion() {
    return <ServiceDetail id="automatizacion" itemPrefix="ai" count={8} heroTestid="automatizacion-hero" gridTestid="automatizacion-servicios" ctaTestid="automatizacion-cta" />;
}
